module.exports = __webpack_public_path__ + "img/certificate-mario_platformer.f356ac44.png";